/*
 * @Author: vinc
 * @LastEditTime: 2020-10-27 10:34:11
 */
import HEAD from '@/components/Head.vue'
import FOOTER from '@/components/Footer.vue'
import MALLHEAD from '@/components/MallHead.vue'
// import NAVMENU from '@/components/Nav_menu.vue'
export default {
    install: function (Vue) {
        Vue.component('public-head', HEAD),
            Vue.component('public-footer', FOOTER),
            Vue.component('public-mallhead', MALLHEAD)
        // Vue.component('public-nav',NAVMENU)
    }
}


// WEBPACK FOOTER //
// ./src/components/index.js